import type { Dimensions } from "schema/agent";
import type { Message, VersionSnapshot } from "@/features/agent";

export enum ChatState {
  IDLE,
  THINKING,
  GENERATING,
  CODING,
}

export interface Project extends VersionSnapshot {
  id: string;
  title: string;
  chatState: ChatState;
  messages: Message[];
  dimensions: Dimensions;
  createdAt: number;
  updatedAt: number;
  /** Present when admin views another user's project */
  ownerId?: string;
  ownerEmail?: string;
  /** Present only for admin users */
  totalCost?: number;
}

export type ProjectData = Omit<Project, "id" | "createdAt" | "updatedAt">;

export type ProjectListItem = Pick<Project, "id" | "title" | "updatedAt" | "totalCost"> & {
  messageCount: number;
};

export type ProjectState = Omit<ProjectData, "title">;
